var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMedium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 11.9999C13.2812 15.1364 10.7558 17.6792 7.64049 17.6792C4.52519 17.6792 2 15.1372 2 11.9999C2 8.86253 4.52538 6.32068 7.64049 6.32068C10.7556 6.32068 13.2812 8.8633 13.2812 11.9999ZM19.4691 11.9999C19.4691 14.9525 18.2063 17.346 16.6487 17.346C15.0912 17.346 13.8284 14.9518 13.8284 11.9999C13.8284 9.04793 15.0912 6.65376 16.6487 6.65376C18.2063 6.65376 19.4691 9.04793 19.4691 11.9999ZM22 11.9999C22 14.6453 21.5558 16.7897 21.008 16.7897C20.4603 16.7897 20.0161 14.6446 20.0161 11.9999C20.0161 9.35515 20.4603 7.20997 21.0082 7.20997C21.5562 7.20997 22 9.35458 22 11.9999Z",
    fill: "#A7A7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic_medium.7d9b15453e3b1a2f6a1ac24e0eb66564.svg";
export { ForwardRef as ReactComponent };